import React from 'react';
import BackgroundControls from './BackgroundControls';
import { Clock, Calendar, Save, Download, Upload, FileImage, FileText, Trash2, Printer } from 'lucide-react';

const RightSidebar = ({
  onShowBackgroundSettings,
  onShowTimeManagement,
  onAddDay,
  onSave,
  onLoad,
  onExportImage,
  onPrint,
  onImport,
  onExport,
  onClearData,
  showPeriodColumn,
  onTogglePeriodColumn
}) => {
  return (
    <div className="w-64 flex-shrink-0 flex flex-col gap-5 h-fit">
      {/* 时间管理区域 */}
      <div className="sidebar-card">
        <h4 className="section-title">时间管理</h4>
        <div className="flex flex-col gap-2">
          <button className="btn btn-primary" onClick={onShowTimeManagement}>
            <Clock size={16} className="mr-2" />
            时间管理
          </button>
          <button className="btn btn-success" onClick={onAddDay}>
            <Calendar size={16} className="mr-2" />
            添加星期
          </button>
          <div className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
            <span className="text-sm text-gray-700">显示节次列</span>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={showPeriodColumn}
                onChange={(e) => onTogglePeriodColumn(e.target.checked)}
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
            </label>
          </div>
        </div>
      </div>
      
      <BackgroundControls
        onShowBackgroundSettings={onShowBackgroundSettings}
      />

      {/* 功能按钮区域 */}
      <div className="sidebar-card">
        <h4 className="section-title">功能操作</h4>
        <div className="flex flex-col gap-2">
          <button className="btn btn-warning" onClick={onExportImage}>
            <FileImage size={16} className="mr-2" />
            导出为图片
          </button>
          <button className="btn btn-info" onClick={() => {
            console.log('🖱️ 打印按钮被点击了！');
            onPrint();
          }}>
            <Printer size={16} className="mr-2" />
            打印课程表
          </button>
          <button className="btn btn-primary" onClick={onSave}>
            <Save size={16} className="mr-2" />
            保存到本地
          </button>
          <button className="btn btn-success" onClick={onLoad}>
            <Download size={16} className="mr-2" />
            从本地恢复
          </button>
          <label className="btn btn-info cursor-pointer">
            <Upload size={16} className="mr-2" />
            导入课程表
            <input
              type="file"
              accept=".json"
              onChange={onImport}
              className="hidden"
            />
          </label>
          <button className="btn btn-secondary" onClick={onExport}>
            <FileText size={16} className="mr-2" />
            导出课程表
          </button>
          <button className="btn btn-danger" onClick={onClearData}>
            <Trash2 size={16} className="mr-2" />
            清除本地数据
          </button>
        </div>
      </div>
    </div>
  );
};

export default RightSidebar;
